import { FC } from 'react'
import classNames from 'classnames'
import { LinkButton } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { Text } from '@/atoms/Text'
import { ExternalCta as EC } from '@/types/codegen-federation'
import { useSafeTrack } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  externalCta: EC
  className?: string
}

const ExternalCta: FC<Props> = ({ externalCta, className }) => {
  const { t } = useTranslate('pif')
  const track = useSafeTrack()
  const carePortalLinkClicked = () => {
    track('Care Portal Link Clicked')
  }
  return (
    <div className={classNames('w-full flex rounded-2xl border-2 border-white @container', className)}>
      <div
        style={{
          backgroundImage: `url(${externalCta?.imageUrl})`,
        }}
        className="relative w-full overflow-hidden rounded-2xl bg-cover bg-center bg-no-repeat px-4 py-6 @2xl:px-8 @2xl:py-20"
      >
        <div
          className="absolute inset-0 z-10"
          style={{
            background:
              'linear-gradient(283.3deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.85) 100%)',
          }}
        />
        <FlexColumn className="relative z-20 mr-auto w-full max-w-[211px] gap-3 text-white @2xl:max-w-[400px]">
          <Text weight="bold" className="photon-heading-xs @2xl:photon-heading-lg w-full">
            {externalCta?.title}
          </Text>
          <Text color="core-gray-200" className="photon-caption-sm @2xl:photon-paragraph-xl">
            {externalCta?.subtitle}
          </Text>
          <LinkButton
            external
            className="mt-2 w-fit text-sm @2xl:text-base"
            href={externalCta?.ctaUrl ?? ''}
            variant="white"
            onClick={carePortalLinkClicked}
          >
            {t('joinTheFight', 'Join The Fight')}
          </LinkButton>
        </FlexColumn>
      </div>
    </div>
  )
}

export default ExternalCta
